

export const SET_CHASSEURS_LOADING = "SET_CHASSEURS_LOADING";
export const SET_CHASSEURS_ERROR = "SET_CHASSEURS_ERROR";

export const FETCH_CHASSEURS_REQUEST = "FETCH_CHASSEURS_REQUEST";
export const FETCH_CHASSEURS_SUCCESS = "FETCH_CHASSEURS_SUCCESS";
export const FETCH_CHASSEURS_FAIL = "FETCH_CHASSEURS_FAIL";

export const CREATE_CHASSEUR_REQUEST = "CREATE_CHASSEUR_REQUEST";
export const CREATE_CHASSEUR_SUCCESS = "CREATE_CHASSEUR_SUCCESS";
export const CREATE_CHASSEUR_FAIL = "CREATE_CHASSEUR_FAIL";

export const UPDATE_CHASSEUR_REQUEST = "UPDATE_CHASSEUR_REQUEST";
export const UPDATE_CHASSEUR_SUCCESS = "UPDATE_CHASSEUR_SUCCESS";
export const UPDATE_CHASSEUR_FAIL = "UPDATE_CHASSEUR_FAIL";

export const DELETE_CHASSEUR_REQUEST = "DELETE_CHASSEUR_REQUEST";
export const DELETE_CHASSEUR_SUCCESS = "DELETE_CHASSEUR_SUCCESS";
export const DELETE_CHASSEUR_FAIL = "DELETE_CHASSEUR_FAIL";

// === Domaines (mini module local) ===
export const FETCH_DOMAINES_REQUEST = "FETCH_DOMAINES_REQUEST";
export const FETCH_DOMAINES_SUCCESS = "FETCH_DOMAINES_SUCCESS";
export const FETCH_DOMAINES_FAIL = "FETCH_DOMAINES_FAIL";

export const setChasseursLoading = (v) => ({ type: SET_CHASSEURS_LOADING, payload: v });
export const setChasseursError = (msg) => ({ type: SET_CHASSEURS_ERROR, payload: msg });

export const fetchChasseursRequest = () => ({ type: FETCH_CHASSEURS_REQUEST });
export const fetchChasseursSuccess = (data) => ({ type: FETCH_CHASSEURS_SUCCESS, payload: data });
export const fetchChasseursFail = (err) => ({ type: FETCH_CHASSEURS_FAIL, payload: err });

export const createChasseurRequest = (payload) => ({ type: CREATE_CHASSEUR_REQUEST, payload });
export const createChasseurSuccess = (data) => ({ type: CREATE_CHASSEUR_SUCCESS, payload: data });
export const createChasseurFail = (err) => ({ type: CREATE_CHASSEUR_FAIL, payload: err });

export const updateChasseurRequest = (id, payload) => ({
    type: UPDATE_CHASSEUR_REQUEST,
    payload: { id, payload },
});
export const updateChasseurSuccess = (data) => ({ type: UPDATE_CHASSEUR_SUCCESS, payload: data });
export const updateChasseurFail = (err) => ({ type: UPDATE_CHASSEUR_FAIL, payload: err });

export const deleteChasseurRequest = (id) => ({ type: DELETE_CHASSEUR_REQUEST, payload: { id } });
export const deleteChasseurSuccess = (id) => ({ type: DELETE_CHASSEUR_SUCCESS, payload: id });
export const deleteChasseurFail = (err) => ({ type: DELETE_CHASSEUR_FAIL, payload: err });

// Domaines
export const fetchDomainesRequest = () => ({ type: FETCH_DOMAINES_REQUEST });
export const fetchDomainesSuccess = (data) => ({ type: FETCH_DOMAINES_SUCCESS, payload: data });
export const fetchDomainesFail = (err) => ({ type: FETCH_DOMAINES_FAIL, payload: err });
